import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class DeleteS3RagDocumentUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (customer: string, document: string): Promise<any> => {
        
        return await this._aiRepository.DeleteS3RagDocument(customer, document);
    }
}

export const DeleteS3RagDocumentUseCaseName = "DeleteS3RagDocumentUseCaseName";
